/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TfaCodeBody } from '../models/TfaCodeBody';
import type { TfaVerificationRequest } from '../models/TfaVerificationRequest';
import type { TfaVerificationResponse } from '../models/TfaVerificationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TwoFactorAuthenticationService {
    /**
     * Generate recovery codes
     * Generates new recovery codes for the authenticated user. Recovery codes can be provided only once.
     * @returns TfaVerificationResponse Recovery codes generated successfully
     * @throws ApiError
     */
    public static generateRecoveryCodes(): CancelablePromise<TfaVerificationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/tfa/recovery-codes',
            errors: {
                400: `Returned if the endpoint was not successful. Following messages
                may be returned in the response body:
                - \`User 2fa is not enabled\`
                - \`Recovery codes are already provided\`
                `,
            },
        });
    }
    /**
     * Generate QR code for two-factor authentication
     * Generate QR code for TFA for the authenticated user
     * @returns string QR is generated
     * @throws ApiError
     */
    public static generateQrCodeImageUri(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/tfa/generate-qr-code',
        });
    }
    /**
     * Enable two-factor authentication
     * Enables TFA for the authenticated user
     * @returns any TFA enabled successfully
     * @throws ApiError
     */
    public static enableTfa({
        requestBody,
    }: {
        requestBody: TfaCodeBody,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/tfa/enable',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Disable two-factor authentication
     * Disables TFA for the authenticated user
     * @returns any TFA disabled successfully
     * @throws ApiError
     */
    public static disableTfa({
        requestBody,
    }: {
        requestBody: TfaCodeBody,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/tfa/disable',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Returned if the endpoint was not successful. Following messages
                may be returned in the response request:
                - \`User 2fa is not enabled\`
                `,
            },
        });
    }
    /**
     * Two-factor authentication
     * Two-factor authentication
     * @returns TfaVerificationResponse Authenticate successfully
     * @throws ApiError
     */
    public static tfAuthenticate({
        requestBody,
    }: {
        requestBody: TfaVerificationRequest,
    }): CancelablePromise<TfaVerificationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/tfa/authenticate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Returned if the endpoint was not successful. Following messages
                may be returned in the response body:
                - \`Invalid user\`
                - \`Invalid token\`
                - \`User 2fa is not enabled\`
                - \`Code is not correct\`
                `,
            },
        });
    }
}
